import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { FormlyModule, FormlyFieldConfig } from '@ngx-formly/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomValidators } from 'ng2-validation';
import { StageSandbox } from '../../services/stage.sandbox';

import * as stageTypes from '../../types';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

import * as jsonTest from '../formDefinitions.json.js';
import { IProcessedData } from '../../../shared/types';
import { FormlyManipulation } from '../../../shared/helpers/generateFormlyData';

import * as _ from 'lodash';
import { AnimationBuilder, AnimationPlayer, useAnimation } from '@angular/animations';
import * as animations from '../../../shared/animations';
import { PopNotificationService } from '../../../shared/services/pop-notification.service';
import { ITasksMetaDef } from '../../types';




@Component({
  selector: 'tr-task-questions-container',
  templateUrl: './task-questions-container.component.html',
  styleUrls: ['./task-questions-container.component.scss']
})
export class TaskQuestionsContainerComponent implements OnChanges, OnInit, OnDestroy {

  @Input() entity: stageTypes.IPage;

  private taskQuestionsForm: FormGroup; // Form
  private taskQuestionsModel = {};
  private pageFields: FormlyFieldConfig[] = []; // Form Config
  private pageName: string;

  private currentPageId$: Observable<number> = this.sb.getCurrentPageId$();
  private pagesLength$: Observable<number> = this.sb.getCurrentStagePageLength$();
  private subscriptions: Array<Subscription> = [];

  private formData: IProcessedData;
  private formOptions: any;

  private updatedFileInfo:any = {};

  private meta = {};

  public video: string = "";
  public starter: boolean = false;

  public maximumScore: number;
  public correctAnswerToContinue: number;
  public numOfQuizQns: number;

  // animations
  @ViewChild('formDataSection') formDataSection: ElementRef;
  @ViewChild('navButtons') navButtons: ElementRef;

  private effect: string;
  private player: AnimationPlayer;

  constructor(
    private cdRef: ChangeDetectorRef,
    private formlySvc: FormlyManipulation,
    private fb: FormBuilder,
    private sb: StageSandbox,
    private builder: AnimationBuilder,
    private notificationSvc: PopNotificationService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    //console.log("init");
    this.meta = this.entity.meta;
    this.video = this.meta['videourl'];
    if(this.meta['type'] == "starter") {
      this.starter = true;
    }
    else if (this.meta['type'] == "induction")
    {
      if (this.meta['type'] == 'induction' && this.meta['correctanswerstocontinue'] != '' && this.meta['maximumscore'] != '' && this.meta['numofquizqns'] != '')
      {
        this.maximumScore = this.meta['maximumscore']; // maximum number of correct answer, can be the number of questions on this task page or less, not all questions on the task are quiz questions, user setup
        this.correctAnswerToContinue = this.meta['correctanswerstocontinue'];// minimum number of correct answers of quiz questions in order to continue, user setup
        this.numOfQuizQns = this.meta['numofquizqns']; // number of quiz questions on this task page, not all questions on the task are quiz questions, the actual number of quiz question on the task page

        console.log("maximum score: " + this.maximumScore);
        console.log("minimum score required to continue: " + this.correctAnswerToContinue);
        console.log("number of quiz questions of this task: " + this.numOfQuizQns);
      }
    }

    // get time delay in seconds from api task meta property, disable formcontrol form fields for x seconds
    if(this.meta['type'] == 'induction' && this.meta['isquiz'] != '' && this.meta['isquiz'] == true)
    {
        if(this.meta['timedelay'] != '' && Number.isInteger(this.meta['timedelay']) && parseInt(this.meta['timedelay']) > 0)
        {
            var timedelay = parseInt(this.meta['timedelay']) * 1000; // x seconds
            // disable the form immediately
            this.taskQuestionsForm.disable();

            // enable the form after x seconds
            setTimeout(() => this.taskQuestionsForm.enable(), timedelay);
            console.log("tq: set time delay: " + timedelay / 1000 + " seconds");
        }
        else
        {
            console.log("tq: missing time delay value");
        }
    }

  }


  // define custom method not validation
  CalculateCorrectAnswers(key, control, meta) {

    // define custom validation method, return validator object, example
    // return (control: AbstractControl): { [key: string]: any } | null => {
      if (_.has(meta, 'allcorrectanswers')) {

        // must be an array
        var selectedAnsArr;
        if (Array.isArray(control.value))
        {
          if (control.value.length == 0) {
            // blank
            selectedAnsArr = [];
            return null; // blank response option
          }
          else
          {
            selectedAnsArr = control.value;
          }
        }
        else
        {
          if (control.value != null && control.value != '')
          {
            // single string value
            selectedAnsArr = control.value.split(' ');
          }
          else
          {
            // blank
            selectedAnsArr = [];
            return null; // blank response option
          }

        }

        var correctAnsArr = null;
        if (meta['allcorrectanswers'][key] != null && meta['allcorrectanswers'][key] != '') {
          var correctAnsArr = meta['allcorrectanswers'][key].split(','); // must be an array
        }

        if (correctAnsArr != null)
        {
          selectedAnsArr = selectedAnsArr.sort();// sort array in order
          correctAnsArr = correctAnsArr.sort(); // sort array in order

          //console.log("selected val");
          //console.log(selectedAnsArr);// selected value in array
          //console.log("correct val");
          //console.log(correctAnsArr); // correct value in , seperated string

          var same = (selectedAnsArr.length === correctAnsArr.length && selectedAnsArr.every(function (value, index) { return value === correctAnsArr[index] }));

          //console.log("same");
          //console.log(same);
          //return same ? { 'correctanswers': false } : { 'wronganswers': false };
          return same;
        }
        else
        {
          console.log("error: t42: " + key + " question response option missing correct answer!");
          return null;
        }

      }
      else
      {
        return null;
      }

      // false tigger validation error
      // true null pass validation

    //};

  }


  onNavigatePage($event) {
    //console.log("navi");
    // submit happens when form is valid
    if (this.taskQuestionsForm.valid && !$event.isDraft) {
      // form is valid, after form validation
      // console.log("valid form");

      // checking correct answers value at page container level
      if (this.meta['type'] == 'induction')
      {
          // extra business rule checking, nothing to do control validator
          // check correct answers
          //console.log(this.taskQuestionsForm);
          let errorWrongCount = 0;
          let correctCount = 0;
          var answersArray = [];
          _.forEach(this.taskQuestionsForm.controls, (value, key) => {

            var re = this.CalculateCorrectAnswers(key, value, this.meta);
            //console.log("answer");
            //console.log(re);
            if (re != null) {
              if (re) {
                correctCount = correctCount + 1; // calculate number of correct answers
                answersArray[key] = true; // set true if key has correct answer
              }
              else {
                errorWrongCount = errorWrongCount + 1; // calculate number of wrong answers
                answersArray[key] = false;// set false if key has wrong answer
              }
            }
            else
            {
              answersArray[key] = null; // blank
            }

          });

          console.log(answersArray);
          console.log("correct answers: " + correctCount);
          console.log("wrong answers: " + errorWrongCount);

          // check business rules here
          if (this.correctAnswerToContinue > this.maximumScore) {
            this.showingErrors('Setup Error', 'Correct Answers Can not be more than Maximum Score. Please contact helpdesk.');
            console.log('Correct Answers Can not be more than Maximum Score. Please contact helpdesk.');

            _.forEach(this.taskQuestionsForm.controls, (value, key) => {
              // looking for missing required field only
              //console.log("missing required field");
              value.setErrors({'user setup error': true});
              value.markAsTouched();

            });

          }

        console.log("number of quiz qns " + this.numOfQuizQns);
        console.log("maximum score " + this.maximumScore);


          if (errorWrongCount > 0) {
            // user at least answers one question wrong
            if (this.numOfQuizQns < this.maximumScore) {
              // there are normal questions and quiz questions on the same task page

              // use numOfQuizQns
              let userCorrectNumOfAnswers = correctCount;
              console.log("A:number of correct quiz question: " + userCorrectNumOfAnswers + " (minimum " + this.correctAnswerToContinue + " required to submit)");
              if (userCorrectNumOfAnswers < this.correctAnswerToContinue) {
                this.showingErrors('', 'You have not answered enough questions correctly to continue. Please try again');

                _.forEach(this.taskQuestionsForm.controls, (value, key) => {
                  // looking for missing required field only
                  //console.log("missing required field");
                  value.setErrors({'failed to reach minimum correct answers': true});
                  value.markAsTouched();

                  // figure out which control is correct/wrong and change form field UI style accordingly
                  this.displayAnswerCheckingResultOnUI(key, answersArray, null);

                });

              }
              else
              {
                  // mark answers accordingly before submit the form
                  if (answersArray.length > 0)
                  {
                    _.forEach(this.taskQuestionsForm.controls, (value, key) => {

                      if (answersArray[key] != null && answersArray[key])
                      {
                        // mark correct before submit
                        this.displayAnswerCheckingResultOnUI(key, null, 'correct');
                      }
                      else if (answersArray[key] != null && !answersArray[key])
                      {
                        // mark wrong before submit
                        this.displayAnswerCheckingResultOnUI(key, null, 'wrong');
                      }
                      else
                      {

                      }
                    });
                  }

                  // submit form
              }
            }
            else
            {
              // use maximumScore
              let userCorrectNumOfAnswers = correctCount;
              console.log("B:number of correct quiz question: " + userCorrectNumOfAnswers + " (minimum " + this.correctAnswerToContinue + " required to submit)");
              if (userCorrectNumOfAnswers < this.correctAnswerToContinue) {
                this.showingErrors('', 'You have not answered enough questions correctly to continue. Please try again');

                _.forEach(this.taskQuestionsForm.controls, (value, key) => {
                    // looking for missing required field only
                    //console.log("missing required field");
                    value.setErrors({'failed to reach minimum correct answers': true});
                    value.markAsTouched();

                    // figure out which control is correct/wrong and change form field UI style accordingly
                    this.displayAnswerCheckingResultOnUI(key, answersArray, null);

                });

              }
              else
              {
                // mark answers accordingly before submit the form
                if (answersArray.length > 0)
                {
                  _.forEach(this.taskQuestionsForm.controls, (value, key) => {

                    if (answersArray[key] != null && answersArray[key])
                    {
                      // mark correct before submit
                      this.displayAnswerCheckingResultOnUI(key, null, 'correct');
                    }
                    else if (answersArray[key] != null && !answersArray[key])
                    {
                      // mark wrong before submit
                      this.displayAnswerCheckingResultOnUI(key, null, 'wrong');
                    }
                    else
                    {

                    }
                  });
                }

                // submit form
              }

            }

          }
          else
          {
            // user answers all questions correctly
            let userCorrectNumOfAnswers = correctCount;
            console.log("C:number of correct quiz question: " + userCorrectNumOfAnswers + " (minimum " + this.correctAnswerToContinue + " required to submit)");
            if (userCorrectNumOfAnswers < this.correctAnswerToContinue) {
              this.showingErrors('', 'You have not answered enough questions correctly to continue. Please try again');

              _.forEach(this.taskQuestionsForm.controls, (value, key) => {
                // looking for missing required field only
                //console.log("missing required field");
                value.setErrors({'failed to reach minimum correct answers': true});
                value.markAsTouched();

              });

            }
            else
            {
                // mark answers accordingly before submit the form
                if (answersArray.length > 0)
                {
                  _.forEach(this.taskQuestionsForm.controls, (value, key) => {

                    if (answersArray[key] != null && answersArray[key])
                    {
                      // mark correct before submit
                      this.displayAnswerCheckingResultOnUI(key, null, 'correct');
                    }
                    else if (answersArray[key] != null && !answersArray[key])
                    {
                      // mark wrong before submit
                      this.displayAnswerCheckingResultOnUI(key, null, 'wrong');
                    }
                    else
                    {

                    }
                  });
                }

                // submit form
            }

          }


      }

      // submit form

    } // error for submit when form is invalid
    if (this.taskQuestionsForm.invalid && !$event.isDraft) {
      // fomr is invalid

      //console.log("invalid form");

      // check required fields

      _.forEach(this.taskQuestionsForm.controls, (value, key) => {

        //if (_.has(value._errors, 'required')) {
          //if (value._errors['required'] == true)
          if (value.errors)
          {
            // looking for missing required field only
            //console.log("missing required field");
            value.markAsTouched();
          }
        //}

      });

      // checking correct answers value at page container level
      if (this.meta['type'] == 'induction') {

        // reset business logic checking errors
        _.forEach(this.taskQuestionsForm.controls, (value, key) => {

          // looking for missing required field only
          //console.log("missing required field");
          var tmp = value._errors;


          value.setErrors(null);
          // only check required field, and add it back, Todo: if there are other time of errors, we need to add them back as well
          if (_.has(tmp, 'required') && tmp['required'])
          {
            value.setErrors({ 'required': true });

            // hide red cross/green tick style
            this.displayAnswerCheckingResultOnUI(key, [], null);
          }

          //
          value.markAsTouched();

          //console.log(value);

        });
      }


    } else {
      // draft

      // continue save

      let _model = _.pickBy(this.getPageModel(), (val, key) => (_.isArray(val)) ?  val.length > 0 : !_.isNil(val) );
      if ($event.isDraft) {
        _model = Object.assign({}, _model, { draft: 1 });
      }

      this.effect = this.sb.navigatePage($event.nextPage,
        _model,
        this.taskQuestionsForm.dirty,
        this.taskQuestionsForm.valid,
        this.updatedFileInfo[this.pageName],
        this.updateQuestionValue.bind(this),
        this.showingErrors.bind(this)
      );

      // reset form status
      this.taskQuestionsForm.markAsPristine();

    }
  }

  displayAnswerCheckingResultOnUI(key, answersArray,mode)
  {
    var tempOptions = this.getTemplateOptionsFromFormConfigByKey(key);
    if (mode == 'correct')
    {
      // mark correct answer
      if (_.has(tempOptions, 'displayCorrect')) {
        tempOptions.displayCorrect = true; // mark correct answer style on UI
      }
      if (_.has(tempOptions, 'displayWrong')) {
        tempOptions.displayWrong = false; // reset wrong answer style on U
      }
    }
    else if (mode == 'wrong')
    {
      // mark wrong answer
      if (_.has(tempOptions, 'displayCorrect')) {
        tempOptions.displayCorrect = false; // reset correct answer style on UI
      }
      if (_.has(tempOptions, 'displayWrong')) {
        tempOptions.displayWrong = true; // mark wrong answer style on U
      }
    }
    else
    {
      if (answersArray.length > 0)
      {
        // {key: true, key: false, key: null, ...}
        if(answersArray[key] == null)// null
        {
          // hide all stylings
          if (_.has(tempOptions, 'displayCorrect')) {
            tempOptions.displayCorrect = false; // reset correct answer style on UI
          }
          if (_.has(tempOptions, 'displayWrong')) {
            tempOptions.displayWrong = false; // reset correct answer style on U
          }
        }
        else
        {
          // mark correct answer
          if (answersArray[key]) {
            if (_.has(tempOptions, 'displayWrong')) {
              tempOptions.displayWrong = false; // reset wrong answer style on UI
            }
            if (_.has(tempOptions, 'displayCorrect')) {
              tempOptions.displayCorrect = true; // display correct answer style on UI
            }
          }
          else
          {
            // mark wrong answer
            if (_.has(tempOptions, 'displayCorrect')) {
              tempOptions.displayCorrect = false; //  reset correct answer style on UI
            }
            if (_.has(tempOptions, 'displayWrong')) {
              tempOptions.displayWrong = true; // display wrong answer style on UI
            }
          }
        }

      }
      else
      {
        // hide red cross/green tick styles
        if (_.has(tempOptions, 'displayCorrect')) {
          tempOptions.displayCorrect = false; //  reset correct answer style on UI
        }
        if (_.has(tempOptions, 'displayWrong')) {
          tempOptions.displayWrong = false; // rest wrong answer style on UI
        }
      }

    }

  }

  getTemplateOptionsFromFormConfigByKey(thisKey)
  {
    for (var i = 0; i < (this.formData.config[0].fieldGroup).length; i++)
    {
      //console.log(this.formData.config[0].fieldGroup[i].fieldGroup);
      for (var j = 0; j < (this.formData.config[0].fieldGroup[i].fieldGroup).length; j++)
      {
        //console.log(this.formData.config[0].fieldGroup[i].fieldGroup[j]);
        if (this.formData.config[0].fieldGroup[i].fieldGroup[j].key == thisKey)
        {

          return this.formData.config[0].fieldGroup[i].fieldGroup[j].templateOptions;

        }
      }
    }
  }

  showingErrors(title: string, body: string) {
    this.notificationSvc.popNotification({
      type: 'error',
      title: title,
      body: body
    });
  }


  private massageAttachmentData(data) {
    if (_.has(data, 'oldFiles')) {
      const oldFiles = _.cloneDeep(data.oldFiles);
      data = _.omitBy(_.omit(data, 'oldFiles'), _.isNil);
      _.forEach(oldFiles, function(value, key) {
        const fileNames: string[] = _.isArray(data[key]) ? data[key] : [data[key]];
        (_.isArray(value) ? value : [value]).map( oldFileName => {
          if (_.indexOf(fileNames, oldFileName) > -1) {
            _.pull(fileNames, oldFileName);
          }
        });
      });

      return _.pickBy(data, (val, key) => (_.isArray(val)) ?  val.length > 0 : !_.isNil(val) );

    }

    return _.omitBy(data, _.isNil);
  }

  private massageData(data) {
    return _.transform(data, (result, value, key) => {
      // ignore key which is in format of "group-x"
      // value is an array of 1 object
      _.merge(result, _.pickBy(value[0], (val, key) => (_.isArray(val)) ? val.length > 0 : !_.isNil(val) ));
    }, {});
  }

  getPageModel() {
    //console.log("get page model");
    if (!_.has(this.taskQuestionsModel, this.pageName)) {
      this.taskQuestionsModel[this.pageName] = this.formData.model;
      this.updatedFileInfo[this.pageName] = {};
      return this.formData.model;
    } else {
      return this.taskQuestionsModel[this.pageName];
    }
  }

  updateQuestionValue(questionId, value, answerIndex?) {
    if (_.isNil(answerIndex)) {
      this.taskQuestionsModel[this.pageName][questionId] = value;
    } else {
      this.taskQuestionsModel[this.pageName][questionId][answerIndex] = value;
    }
  }

  processFileInfo (configDef: FormlyFieldConfig[]): FormlyFieldConfig[] {
    //console.log(this.updatedFileInfo);
    let pageFileInfo = this.updatedFileInfo[this.pageName];
    configDef[0].fieldGroup.map( (field) =>
      field.fieldGroup.map( subField => {
        if (_.has(pageFileInfo, subField.key) && ((subField.type === 'file') || (subField.type === 'files') )) {
          if (!subField.templateOptions.fileInfo.length) {
            subField.templateOptions.fileInfo = [];
          }
          _.forEach(pageFileInfo[subField.key], (value, key) => {
            subField.templateOptions.fileInfo.push(value);
          });
        }
      })
    );

    return configDef;
  }

  // lifecycles
  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach(sub => sub.unsubscribe());
    //this.sb.onComponentDestroy();
  }

  ngOnChanges(changes: SimpleChanges) {
      //console.log("ngonchanges");
      // normal onchange has this.entity value
      this.pageName = this.entity.name;
      this.taskQuestionsForm = this.fb.group({});
      this.formData = this.formlySvc.process(this.entity);
      this.pageFields = this.processFileInfo(this.formData.config);

      //console.log(this.pageFields);

      this.formOptions = {
        uploader: this.sb.getUploader(),
        sandbox: this.sb,
        formState: {
          disabled: true,
          model: this.formData.model
        }
      };

      if (this.effect) {
        this.applyAnimation();
      }

      window.scrollTo(0, 0);
      this.cdRef.detectChanges();
  }

  applyAnimation() {
    setTimeout(() => {
      const factory = this.builder.build([
        useAnimation(animations.slideAnimation, {
          params: {
            from: '100%', // using if need fadeIndown when Previous is clicked and fadeInUp when Next is clicked  (this.effect === 'fadeInDown') ? '-100%' : '100%',
            to: '0'
          }
        })
      ]);

      this.player = factory.create(this.formDataSection.nativeElement, {});
      this.player.play();
    });
  }

  hasVideo () {
    if(this.video != "" ) {
      return true;
    }
    return false;
  }

  isStarter() {
    return this.starter;
  }

  getVideo() {
      var url = this.video;
      var videoid = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
      if(videoid != null) {
        var embed  = "https://www.youtube.com/embed/" + videoid[1] ;
        // 01/12/2025 Anopan Kandiah ADO-135795: Added 'referrerPolicy="strict-origin-when-cross-origin"' to allow embedded YouTube videos to play without encountering "Error 153".
        return '<iframe src="' + embed + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen style="border: 0;height: 100%;left: 0;position: absolute;top: 0;width: 100%;" referrerPolicy="strict-origin-when-cross-origin"></iframe>';
      } else {
          console.log("The youtube url is not valid.");
          return;
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/task-questions-container/task-questions-container.component.ts